// src/features/reports/KpiSpinner.jsx
//
// Small inline spinner for report-card KPI tiles while data is fetching.
// Renders a 22px / 3px ring (white top arc on semi-transparent ring) with
// a visible "Loading…" label that is also accessible to screen readers.
//
// The keyframe is injected once into <head> so it does not require a global
// CSS file and does not duplicate style nodes across multiple instances.

import React from "react";
import { T } from "../../app/tokens.js";

const KEYFRAME_ID = "kpi-spinner-keyframes";

function ensureKeyframes() {
  if (typeof document === "undefined") return;
  if (document.getElementById(KEYFRAME_ID)) return;
  const style = document.createElement("style");
  style.id = KEYFRAME_ID;
  style.textContent = "@keyframes kpi-spin { to { transform: rotate(360deg); } }";
  document.head.appendChild(style);
}

export function KpiSpinner() {
  ensureKeyframes();
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <span
        data-testid="kpi-spinner"
        role="status"
        aria-label="Loading…"
        style={{
          display: "inline-block",
          width: 22,
          height: 22,
          borderRadius: "50%",
          border: "3px solid rgba(255,255,255,0.25)",
          borderTopColor: T.white,
          animation: "kpi-spin 0.8s linear infinite",
          flexShrink: 0,
        }}
      />
      <span
        aria-hidden="true"
        style={{
          fontSize: T.fsSm,
          color: "rgba(255,255,255,0.65)",
          fontWeight: T.fwSemibold,
        }}
      >
        Loading…
      </span>
    </span>
  );
}
